import { useCallback, useEffect, useState } from "react";
import { getCompanyAccessName } from "../App";

const useFetchSingleElements = (companyAccessname, type, id) => {
  const [data, setData] = useState({
    loading: true,
    error: null,
    element: [],
  });

  const resolvedCompanyAccessName =
    companyAccessname || getCompanyAccessName();

  const buildFetchUrl = useCallback(() => {
    if (!resolvedCompanyAccessName || !type || !id) {
      return null;
    }

    const baseUrl = process.env.API_BASE_URL + `/pcw/${resolvedCompanyAccessName}`;
    switch (type) {
      case "stories":
        return `${baseUrl}/stories/${id}`;
      case "jobs":
        return `${baseUrl}/jobs/${id}`;
      case "events":
        return `${baseUrl}/events/${id}`;
      case "medien":
        return `${baseUrl}/media/${id}`;
      default:
        return null;
    }
  }, [resolvedCompanyAccessName, type, id]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchUrl = buildFetchUrl();
      if (!fetchUrl) {
        setData({ loading: false, error: "Invalid fetch parameters", element: [] });

        return;
      }

      try {
        const response = await fetch(fetchUrl, {
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonData = await response.json();

        setData({
          loading: false,
          error: null,
          element: Array.isArray(jsonData) ? jsonData : [jsonData],
        });
      } catch (error) {
        setData({
          loading: false,
          error: error.message || "An unknown error occurred",
          element: [],
        });
      }
    };

    fetchData();
  }, [buildFetchUrl]);

  return data;
};

export default useFetchSingleElements;
